

import Client from "@searchkit/instantsearch-client";
import Searchkit from "searchkit";

export const indexName = 'contentful-entries';

const sk = new Searchkit({
    connection: {
        host: "https://27744cc57d384974baaa3785171b1233.europe-west4.gcp.elastic-cloud.com/",
        headers: {
            "Authorization": "Basic d2Vic2l0ZV9ta2JzZXJ2aWNlZGVzazp3ZWJzaXRlX21rYnNlcnZpY2VkZXNr"
        }
    },
    search_settings: {
        search_attributes: [
            { field: 'title', weight: 5 },
            { field: 'subtitle', weight: 4 },
            { field: 'description', weight: 2 },
            'body',
            'title.keyword'
        ],
        result_attributes: [
            "title",
            "subtitle",
            "description",
            "body",
            "url",
            "desk",
            "deskSlug",
            "deskCategory",
            "deskCategorySlug",
            "pillTypes",
            "imageUrl"
        ],
        facet_attributes: [
            {
                attribute: 'desk',
                field: 'desk.keyword',
                type: 'string',
            },
            {
                attribute: 'deskCategory',
                field: 'deskCategory.keyword',
                type: 'string',
            },
            {
                attribute: 'pillTypes',
                field: 'pillTypes.keyword',
                type: 'string',
            }
        ],
    },
})

export const searchClient = Client(sk)